module.exports = __webpack_public_path__ + "static/img/getBtn.70d4964.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diwali/getBtn.png
// module id = AVMv
// module chunks = 0